<template>
    <div class="label-box flex">
        <div class="label">
            <span>
                <span v-if="required" class="col-red">*</span>
                {{label}}
            </span>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name:'labelBox',
    props:{
        required:{
            type: Boolean,
            default: false
        },
        label:{
            type:String,
            default:''
        }
    },
    data(){
        return {

        }
    }
}
</script>
<style scoped>
    .label,
    .content{
        display: inline-block;
    }
    .label{
        min-width: 85px;
        padding: 0 10px;
        line-height: 40px;
        /* align-items: center; */
        display: flex;
        justify-content: flex-end;
    }
    .content{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/labelBox.vue